import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef } from "react";
import { BadgeContainer } from "./styles";
export var CounterBadge = forwardRef(function CounterBadge(_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 20 : _b, customColor = _a.customColor, children = _a.children, props = __rest(_a, ["size", "customColor", "children"]);
    var spanRef = useRef(null);
    useEffect(function () {
        if (spanRef.current) {
            var span = spanRef.current;
            var fontSize = Number(span.style.fontSize.replace("px", "")) || 0.5 * size;
            var spanWidth = span.getBoundingClientRect().width;
            var sizeWithPadding = size - 8;
            var proportion = sizeWithPadding / spanWidth;
            span.style.fontSize = "".concat(Math.min(0.5 * size, proportion * fontSize), "px");
        }
    }, [children]);
    return (_jsx(BadgeContainer, __assign({ ref: ref, size: size, color: customColor }, props, { children: _jsx("span", { ref: spanRef, children: children }) })));
});
//# sourceMappingURL=index.js.map